import { createSlice } from '@reduxjs/toolkit';
import { resetPassword, updateProfileData } from './thunks';

export interface ProfileState {
  passwordResetSuccess?: boolean | undefined;
  passwordResetError?: string;
  updateProfileDataSuccess?: boolean | undefined;
  updateProfileDataError?: string;
  loading: boolean;
}

const initialState: ProfileState = {
  passwordResetSuccess: undefined,
  passwordResetError: undefined,
  updateProfileDataSuccess: undefined,
  updateProfileDataError: undefined,
  loading: true,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    passwordResetFinished: (state) => {
      state.passwordResetSuccess = undefined;
      state.passwordResetError = undefined;
    },
  },
  extraReducers: (builder) => {
    // password reset
    builder.addCase(resetPassword.pending, (state) => {
      state.passwordResetError = initialState.passwordResetError;
      state.passwordResetSuccess = initialState.passwordResetSuccess;
      state.loading = initialState.loading;
    });
    builder.addCase(resetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.passwordResetSuccess = action.payload;
    });
    builder.addCase(resetPassword.rejected, (state, action) => {
      state.loading = false;
      state.passwordResetError = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
      state.passwordResetSuccess = false;
    });

    // update profile data
    builder.addCase(updateProfileData.pending, (state) => {
      state.updateProfileDataError = initialState.updateProfileDataError;
      state.updateProfileDataSuccess = initialState.updateProfileDataSuccess;
      state.loading = initialState.loading;
    });
    builder.addCase(updateProfileData.fulfilled, (state, action) => {
      state.loading = false;
      state.updateProfileDataSuccess = action.payload;
    });
    builder.addCase(updateProfileData.rejected, (state, action) => {
      state.loading = false;
      state.updateProfileDataError = action.payload
        ? (action.payload as Error)?.message
        : action.error?.message;
      state.updateProfileDataSuccess = false;
    });
  },
});

export const { passwordResetFinished } = profileSlice.actions;

export default profileSlice.reducer;
